exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".us-life .banner img {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.us-life .card {\r\n  border: none;\r\n}\r\n\r\n.us-life .us-life-item a,\r\n.us-life .us-life-item a:link {\r\n  color: #49525a;\r\n  text-decoration: none;\r\n}\r\n\r\n.us-life .us-life-item:hover .us-life-title{\r\n  color: #85baac;\r\n}\r\n\r\n.us-life .us-life-item:hover img {\r\n  -webkit-transform: scale(1.05);\r\n          transform: scale(1.05);\r\n}\r\n\r\n.us-life-desc {\r\n  /*position: relative;*/\r\n  /*line-height: 1.5rem;*/\r\n  /*!* 高度为需要显示的行数*行高，比如这里我们显示两行，则为3 *!*/\r\n  /*height: 4.5rem;*/\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n}\r\n\r\n/*.us-life-desc:after {*/\r\n\r\n/*content: \"...\";*/\r\n\r\n/*position: absolute;*/\r\n\r\n/*bottom: 0;*/\r\n\r\n/*right: 0;*/\r\n\r\n/*padding: 0 5px;*/\r\n\r\n/*background-color: #fff;*/\r\n\r\n/*}*/\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/us-life/us-life/us-life.component.css
// module id = ../../../../../src/app/components/us-life/us-life/us-life.component.css
// module chunks = main